import React from 'react'
import Card from '../shared/Card'

/**
 * Account Overview component for displaying user metrics
 * Handles both mobile and desktop layouts
 * 
 * @param {Array} accountOverview - Array of metric objects
 * @param {boolean} loading - Loading state
 * @param {boolean} isMobile - Whether to show mobile layout
 */
const AccountOverview = ({ accountOverview, loading, style = "icon", className, direction = "column", cardBevelStyle = ""}) => {
  if (style === "grid") {
    return (
      <section className={`mb-8 ${className}`}>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-medium text-gray-700">Account Overview</h2>
        </div>
        
        <Card className={`p-4 ${cardBevelStyle}`} shadow="small">
          {/* Two-Column Metrics Grid */}
          <div className="grid grid-cols-2 gap-6">
            {/* Left Column - First half of metrics */}
            <div className="space-y-4">
              {accountOverview.slice(0, Math.ceil(accountOverview.length / 2)).map((item, index) => (
                <div key={index}>
                  <div className="text-sm text-gray-600 mb-1">{item.title}</div>
                  <div className={`text-lg font-semibold ${loading ? 'text-gray-400' : 'text-gray-900'}`}>
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
            
            {/* Right Column - Second half of metrics */}
            <div className="space-y-4">
              {accountOverview.slice(Math.ceil(accountOverview.length / 2)).map((item, index) => (
                <div key={index}>
                  <div className="text-sm text-gray-600 mb-1">{item.title}</div>
                  <div className={`text-lg font-semibold ${loading ? 'text-gray-400' : 'text-gray-900'}`}>
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </section>
    )
  } else if (style === "icon") {
    return (
      // <section className={`hidden lg:block ${className}`}>
      <section className={`lg:block ${className}`}>

        <Card 
          shadow="medium"
          title="Account Overview"
          className={cardBevelStyle}
        >
          <div className={`flex ${direction === "row" ? "flex-col space-y-6 lg:flex-row lg:space-x-6 lg:space-y-0" : "flex-col space-y-6"}`}>
            {accountOverview.map((item, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className={`w-10 h-10 ${item.color} rounded-full flex items-center justify-center flex-shrink-0`}>
                  <item.icon className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-gray-900 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <p className={`text-lg font-bold ${loading ? 'text-gray-400' : 'text-gray-900'}`}>
                      {item.value} 
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </section>
    )
  }


}

export default AccountOverview
